import { usePluginData } from './usePluginData';
import type { Board } from './PluginHeaderButton.types';

export const useHasDeprecatedPlugins = (board: Board) => {
  const { isLoading, error, pluginsData } = usePluginData(board);

  if (isLoading || error) {
    return false;
  }

  return (
    pluginsData?.plugins.some(
      (plugin) => plugin.attributes.deprecation?.sunsetDate,
    ) ?? false
  );
};
